module.exports = __webpack_public_path__ + "static/media/Faded.2479fe52.txt";